import React, { useState } from 'react';
import {
    Box,
    Grid,
    TextField,
    FormControl,
    Typography,
    Button,
    Select,
    MenuItem,
    Card,
    CardContent,
} from '@mui/material';
import { AllEducationList } from '../../utils/dropOptions';
import AddressForm from '../../components/address-form/AddressForm';

function Education({ onNext }) {
    const [education, setEducation] = useState({
        institutionName: '',
        highestLevelCompleted: '',
        address: {
            line1: '',
            line2: '',
            city: '',
            stateProvince: '',
            postalCode: '',
            country: '',
        }
    });

    const handleEducationChange = (field) => (event) => {
        setEducation({
            ...education,
            [field]: event.target.value
        });
    };

    const handleAddressFieldChange = (field, value) => {
        setEducation({
            ...education,
            address: {
                ...education.address,
                [field]: value
            }
        });
    };


    const handleSubmit = () => {
        onNext();
    };

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
            <Typography variant="h6" gutterBottom>Education History</Typography>

            <Card variant="outlined" sx={{ mb: 3 }}>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Institution Name"
                                value={education.institutionName}
                                onChange={handleEducationChange('institutionName')}
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl fullWidth required>
                                <Select
                                    value={education.highestLevelCompleted}
                                    onChange={handleEducationChange('highestLevelCompleted')}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>Select Highest Level Completed</MenuItem>
                                    {AllEducationList.map((level) => (
                                        <MenuItem key={level} value={level}>
                                            {level.replace(/_/g, ' ').replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1))}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="subtitle1" gutterBottom>Institution Address</Typography>
                            <AddressForm
                                address={education.address}
                                onChange={handleAddressFieldChange}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Box sx={{ mt: 3 }}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSubmit}
                >
                    Continue
                </Button>
            </Box>
        </Box>
    );
}

export default Education;
